import { render, staticRenderFns } from "./TaxPaymentList.vue?vue&type=template&id=e6e53b24&scoped=true&"
import script from "./TaxPaymentList.vue?vue&type=script&lang=js&"
export * from "./TaxPaymentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e53b24",
  null
  
)

export default component.exports